import firstBy from 'thenby';

const STATUS_SORT_ORDER = [
  "preparing",
  "scheduled",
  "pending",
  "running",
  "error",
  "done",
  "complete",
  "expired"
];


export default function sortByJobStatusOrder(order) {
  return firstBy((a, b) => {
    const aIndex = STATUS_SORT_ORDER.indexOf(a.status);
    const bIndex = STATUS_SORT_ORDER.indexOf(b.status);

    if (aIndex === -1 || bIndex === -1) {
      return 0;
    }

    if (order === 'asc') {
      return aIndex - bIndex;
    }

    return bIndex - aIndex;
  });
};
